// Location constants and utilities
export const LOCATIONS = {
  BAR: "bar",
  COFFEE_SHOP: "coffee_shop",
  MERCHANDISE: "merchandise",
};

export const LOCATION_OPTIONS = [
  { value: LOCATIONS.BAR, label: "Bar", icon: "🍸" },
  { value: LOCATIONS.COFFEE_SHOP, label: "Coffee Shop", icon: "☕" },
  { value: LOCATIONS.MERCHANDISE, label: "Merchandise", icon: "🛍️" },
];

// Get location label by value
export const getLocationLabel = (value) => {
  const location = LOCATION_OPTIONS.find((opt) => opt.value === value);
  return location ? location.label : value;
};

// Get location icon by value
export const getLocationIcon = (value) => {
  const location = LOCATION_OPTIONS.find((opt) => opt.value === value);
  return location ? location.icon : "";
};

// Get location info (icon + label) by value
export const getLocationInfo = (value) => {
  const location = LOCATION_OPTIONS.find((opt) => opt.value === value);
  return location ? { icon: location.icon, label: location.label } : null;
};

// LocalStorage keys - Updated untuk support multiple locations
export const STORAGE_KEYS = {
  CASHIER_LOCATION: "cashier_location", // Tetap gunakan key ini untuk backward compatibility
  CASHIER_SESSION_PREFIX: "cashier_session_", // Prefix untuk location-specific sessions
  SAVED_BILLS: "savedBills",
};

// Location management functions - Updated
export const saveCashierLocation = (location) => {
  if (location && Object.values(LOCATIONS).includes(location)) {
    localStorage.setItem(STORAGE_KEYS.CASHIER_LOCATION, location);
    return true;
  }
  return false;
};

export const getCashierLocation = () => {
  return localStorage.getItem(STORAGE_KEYS.CASHIER_LOCATION);
};

// New functions untuk multiple location support
export const saveCashierSessionData = (location, sessionData) => {
  if (location) {
    const key = `${STORAGE_KEYS.CASHIER_SESSION_PREFIX}${location}`;
    localStorage.setItem(key, JSON.stringify(sessionData));
    // Juga set current active location
    localStorage.setItem(STORAGE_KEYS.CASHIER_LOCATION, location);
    return true;
  }
  return false;
};

export const getCashierSessionData = (location) => {
  const key = `${STORAGE_KEYS.CASHIER_SESSION_PREFIX}${location}`;
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : null;
};

export const clearCashierSessionData = (location) => {
  const key = `${STORAGE_KEYS.CASHIER_SESSION_PREFIX}${location}`;
  localStorage.removeItem(key);

  // Jika ini adalah current active location, hapus juga current location
  const currentLocation = getCashierLocation();
  if (currentLocation === location) {
    clearCashierLocation();
  }
};

export const getAllCashierSessions = () => {
  const sessions = {};
  Object.values(LOCATIONS).forEach((location) => {
    const sessionData = getCashierSessionData(location);
    if (sessionData) {
      sessions[location] = sessionData;
    }
  });
  return sessions;
};

export const clearCashierLocation = () => {
  localStorage.removeItem(STORAGE_KEYS.CASHIER_LOCATION);
};
